// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class CaseTypeModel {
    static getAttributeTypeMap() {
        return CaseTypeModel.attributeTypeMap;
    }
}
CaseTypeModel.discriminator = undefined;
CaseTypeModel.additionalProperties = false;
CaseTypeModel.attributeTypeMap = [
    {
        "name": "caseTypeId",
        "baseName": "caseTypeId",
        "type": "number"
    },
    {
        "name": "caseTypeCategoryCode",
        "baseName": "caseTypeCategoryCode",
        "type": "string"
    },
    {
        "name": "caseTypeCategoryDescription",
        "baseName": "caseTypeCategoryDescription",
        "type": "string"
    },
    {
        "name": "caseTypeCode",
        "baseName": "caseTypeCode",
        "type": "string"
    },
    {
        "name": "caseTypeDescription",
        "baseName": "caseTypeDescription",
        "type": "string"
    },
    {
        "name": "caseTypeCategoryId",
        "baseName": "caseTypeCategoryId",
        "type": "number"
    },
    {
        "name": "createdFromIntake",
        "baseName": "createdFromIntake",
        "type": "boolean"
    },
];
//# sourceMappingURL=caseTypeModel.js.map